<template class="full-height">
  <div
    class="view-point-app-container itinerary"
    style="position: relative; height: 100%; padding: 10px"
  >
    <el-dialog
      v-if="currentItineraryPlanningRow && currentItineraryPlanningRow.theDay"
      :top="dialogTopMargin"
      :title="'行程規劃資料'"
      :visible.sync="currentItineraryPlanningRowVisible"
      width="85%"
    >
      <el-card>
        <div slot="header" class="clearfix">
          <span>行程設定</span>

          <el-button
            style="float: right; padding: 6px 15px; margin-left: 10px"
            type="danger"
            @click="currentItineraryPlanningRowVisible = false"
            >關 閉</el-button
          >
        </div>

        <el-tabs v-model="planningTab" type="border-card">
          <el-tab-pane label="精彩行程" name="thisTimes" v-if="currentItineraryPlanningRow.theDay">
            <el-col :span="12">
              <el-form
                class="itinerary"
                :disabled="true"
                label-width="130px"
                size="mini"
                label-position="right"
              >
                <el-form-item label="出發時間">
                  <el-time-select
                    v-model="currentItineraryPlanningRow.theDay.departureTime"
                    :picker-options="{
                      start: '08:00',
                      step: '00:10',
                      end: '23:30',
                    }"
                    format="HH:mm"
                    value-format="HH:mm"
                    placeholder="出發時間"
                  >
                  </el-time-select>
                </el-form-item>
                <el-form-item label="出發集合地點">
                  <el-input v-model="currentItineraryPlanningRow.theDay.assemblingPlace" />
                </el-form-item>

                <el-form-item label="旅館名稱">
                  <el-input v-model="currentItineraryPlanningRow.theDay.hotelName" />
                </el-form-item>

                <el-form-item label="上午景點">
                  <el-input v-model="currentItineraryPlanningRow.theDay.morningSights" />
                </el-form-item>

                <el-form-item label="下午景點">
                  <el-input v-model="currentItineraryPlanningRow.theDay.afternoonAttractions" />
                </el-form-item>

                <el-form-item label="早餐">
                  <el-input v-model="currentItineraryPlanningRow.theDay.breakfast" />
                </el-form-item>

                <el-form-item label="午餐">
                  <el-input v-model="currentItineraryPlanningRow.theDay.lunch" />
                </el-form-item>

                <el-form-item label="晚餐">
                  <el-input v-model="currentItineraryPlanningRow.theDay.dinner" />
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form
                class="itinerary"
                :disabled="true"
                label-width="130px"
                size="mini"
                label-position="right"
              >
                <el-form-item label="晚間景點">
                  <el-input v-model="currentItineraryPlanningRow.theDay.eveningAttractions" />
                </el-form-item>

                <el-form-item label="預計返回旅館時間">
                  <el-time-select
                    v-model="currentItineraryPlanningRow.theDay.returnHotelTime"
                    :picker-options="{
                      start: '08:00',
                      step: '00:10',
                      end: '23:30',
                    }"
                    format="HH:mm"
                    value-format="HH:mm"
                    placeholder="預計返回旅館時間"
                  >
                  </el-time-select>
                </el-form-item>

                <el-form-item label="本日行程注意事項">
                  <el-input v-model="currentItineraryPlanningRow.theDay.notesOnToday" />
                </el-form-item>

                <el-form-item label="行程手冊上傳"> </el-form-item>
              </el-form>
            </el-col>
          </el-tab-pane>
          <el-tab-pane label="行程規劃" name="thisDays" v-if="currentItineraryPlanningRow.thisTime">
            <div style="overflow-y: scroll; height: 500px">
              <el-form
                class="itinerary"
                :disabled="true"
                v-for="(item, index) in currentItineraryPlanningRow.thisTime.data"
                :key="index"
                :inline="true"
                size="mini"
              >
                <el-form-item label="" size="mini">
                  <el-tag>Day{{ index + 1 }}</el-tag>
                </el-form-item>

                <el-form-item label="行程說明" style="width: 90%" class="widh-input">
                  <el-col class="line" :span="24">
                    <el-input
                      v-model="item.description"
                      style="width: 100%"
                      placeholder="行程說明"
                    />
                  </el-col>
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </el-dialog>

    <el-dialog
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      :title="'新增景點'"
      :visible.sync="viewPointDialogVisible"
      width="50%"
    >
      <el-card class="box-card">
        <el-form ref="vsForm" :model="vsForm" :label-width="formLabelWidth">
          <el-form-item
            :label="funcName + '使用區域'"
            prop="countryAreaList"
            :rules="[{ required: true, message: '請輸入景點區域', trigger: 'change' }]"
          >
            <el-cascader
              clearable
              v-model="vsForm.countryAreaList"
              :props="{ checkStrictly: true, expandTrigger: 'hover' }"
              style="width: 100%"
              placeholder="請選擇"
              filterable
              :options="travelAttractionsMenu"
            >
            </el-cascader>
          </el-form-item>

          <el-form-item
            :label="funcName + '名稱'"
            prop="viewPointName"
            :rules="[{ required: true, message: '請輸入景點名稱', trigger: 'blur' }]"
          >
            <el-input v-model="vsForm.viewPointName"></el-input>
          </el-form-item>

          <el-form-item :label="funcName + '座標'">
            <el-row>
              <el-col :span="12">
                <el-form-item
                  label="北緯(lat)"
                  prop="lat"
                  :rules="[
                    {
                      required: true,
                      message: '請輸座標北緯度',
                      trigger: 'blur',
                    },
                    { type: 'number', message: '座標緯度必須為數字' },
                  ]"
                >
                  <el-input v-model.number="vsForm.lat"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="東經(lng)"
                  prop="lng"
                  :rules="[
                    {
                      required: true,
                      message: '請輸座標東經度',
                      trigger: 'blur',
                    },
                    { type: 'number', message: '座標經度必須為數字' },
                  ]"
                >
                  <el-input v-model.number="vsForm.lng"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button @click="viewPointDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveViewpointData">確 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      v-if="
        currentPositionData && currentPositionData.records && currentPositionData.records.length > 0
      "
      :title="'定位足跡紀錄'"
      :visible.sync="positionDialogVisible"
      top="2%"
      width="70%"
    >
      <div style="position: relative; height: 100%; padding: 10px">
        <el-table
          v-loading="listLoading"
          size="mini"
          :data="currentPositionData.records"
          border
          fit
          highlight-current-row
          height="600px"
        >
          <el-table-column align="center" label="項次" width="60">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="日期" width="90">
            <template slot-scope="scope">
              <span>{{ scope.row.date }}</span>
            </template>
          </el-table-column>

          <el-table-column align="left" label="景點" width="250">
            <template slot-scope="scope">
              <span>{{ scope.row.viewPointName }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="到達時間" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.startTime }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="離開時間" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.leaveTime }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="停留時間" width="120">
            <template slot-scope="scope">
              <span>{{ scope.row.dwellTime }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="北緯" width="110">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.lat" type="success">{{ scope.row.lat }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column align="center" label="東經" width="110">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.lng" type="success">{{ scope.row.lng }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column align="center" label="功能" width="300">
            <template slot-scope="scope" v-if="scope.row.lat && scope.row.lng">
              <el-row>
                <el-col :span="12">
                  <el-button
                    size="mini"
                    @click="googleMap(scope.row)"
                    icon="el-icon-position"
                    type="success"
                    >查看Google地圖</el-button
                  ></el-col
                >
                <el-col :span="12">
                  <el-button
                    icon="el-icon-plus"
                    type="warning"
                    size="mini"
                    @click="addToViewpoint(scope.row)"
                    >添加至景點管理</el-button
                  ></el-col
                >
              </el-row>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog
      @open="getDataReference"
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      :title="funcName + '維護'"
      :visible.sync="dialogVisible"
      width="90%"
    >
      <el-card class="box-card">
        <el-form ref="form" :model="form" :label-width="formLabelWidth" :disabled="false">
          <el-row>
            <el-col :span="9">
              <el-form-item v-if="form.id" :label="'狀態'">
                <el-tag :type="form.status | statusFilter">{{ form.statusDesc }}</el-tag>

                <el-tag style="margin-left: 5px" type="success">{{
                  `申請時間：${form.buildDate}`
                }}</el-tag>
              </el-form-item>

              <el-form-item :label="'申請項目'" prop="applyType">
                <el-tag>{{ form.applyTypeDesc }}</el-tag>
              </el-form-item>

              <el-form-item
                :label="'資訊需求團號'"
                prop="applyTourNo"
                :rules="[
                  {
                    required: true,
                    message: '請填寫紀錄資訊需求團號',
                    trigger: 'change',
                  },
                ]"
              >
                <el-tag type="success">{{ form.applyTourNo }}</el-tag>
              </el-form-item>

              <el-form-item
                :label="'資訊需求團名'"
                prop="applyTravelName"
                :rules="[
                  {
                    required: true,
                    message: '請填寫紀錄資訊需求團號',
                    trigger: 'change',
                  },
                ]"
              >
                <el-tag type="success">{{ form.applyTravelName }}</el-tag>
              </el-form-item>

              <el-form-item
                :label="'資訊需求日期時間範圍'"
                prop="applyDates"
                :rules="[
                  {
                    required: true,
                    message: '請選擇資訊需求日期時間範圍',
                    trigger: 'change',
                  },
                ]"
              >
                <el-date-picker
                  :disabled="true"
                  v-loading="dateInfoLoading"
                  :picker-options="pickerOptions"
                  style="width: 100%"
                  v-model="form.applyDates"
                  type="datetimerange"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm"
                  range-separator="至"
                  start-placeholder="開始日期"
                  end-placeholder="結束日期"
                >
                </el-date-picker>
              </el-form-item>

              <el-form-item
                v-if="showUserOptionsApplyTypeIDs.includes(form.applyType)"
                :label="'資訊需求人物姓名'"
                prop="applyUserID"
                :rules="[
                  {
                    required: true,
                    message: '請填寫紀錄資訊需求人物姓名',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-select
                  :disabled="true"
                  v-loading="dateInfoLoading"
                  style="width: 100%"
                  v-model="form.applyUserID"
                  clearable
                  placeholder="請選擇旅客"
                >
                  <el-option
                    v-for="item in travelers"
                    :key="item.userID"
                    :label="`${item.name}`"
                    :value="item.userID"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                prop="applyDescription"
                :label="'發生經過'"
                :rules="[
                  {
                    required: true,
                    message: '請詳細填寫客訴發生經過，以及需求何種紀錄為參考依據',
                    trigger: 'blur',
                  },
                ]"
              >
                <div>
                  <span>請詳細填寫客訴發生經過，以及需求何種紀錄為參考依據。</span>
                  <el-input
                    :disabled="true"
                    id="remarkAreaContent"
                    type="textarea"
                    :rows="10"
                    v-model="form.applyDescription"
                  ></el-input>
                </div>
              </el-form-item>
            </el-col>

            <el-col :offset="1" :span="14">
              <el-alert
                v-if="form.applyType != 8"
                :title="`自${form.applyDates[0]}至${form.applyDates[0]}，申請【${form.applyTypeDesc}】資料共計：${referenceData.length} 筆。日期最新排在最上方。`"
                :closable="false"
                type="success"
              >
              </el-alert>

              <div style="position: relative; height: 80%">
                <div v-if="form.applyType == 8">
                  <el-tag type="success" style="margin: 5px">請輸入審核說明</el-tag>
                  <el-input
                    :disabled="form.status != 1"
                    type="textarea"
                    :rows="20"
                    style="height: 20%"
                    v-model="successRemark"
                    placeholder="請輸入說明"
                  ></el-input>
                </div>

                <!-- 公告資料 -->
                <el-table
                  v-if="form.applyType == 1"
                  v-loading="listLoading"
                  size="mini"
                  :data="referenceData"
                  border
                  fit
                  highlight-current-row
                  height="600px"
                >
                  <el-table-column align="center" label="項次" width="60">
                    <template slot-scope="scope">
                      <span>{{ scope.$index + 1 }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column align="center" label="時間" width="180">
                    <template slot-scope="scope">
                      <el-tag>{{ scope.row.buildDate }}</el-tag>
                    </template>
                  </el-table-column>

                  <el-table-column align="center" label="建立者" width="130">
                    <template slot-scope="scope">
                      <el-tag>{{ scope.row.buildUserName }}</el-tag>
                    </template>
                  </el-table-column>

                  <el-table-column align="center" label="公告內容" width="300">
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.data.bulletinBoard">{{
                        scope.row.data.bulletinBoard | cuttingText
                      }}</el-tag>
                      <el-tag v-else :type="'danger'">無內容</el-tag>
                    </template>
                  </el-table-column>

                  <el-table-column align="center" label="查看" width="120">
                    <template slot-scope="scope">
                      <el-button
                        v-if="form.applyType == 1 && scope.row.data.bulletinBoard"
                        type="primary"
                        @click="viewReferenceData(scope.row)"
                        :disabled="false"
                        >查看內容</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
                <!-- 攜帶物品資料 -->
                <el-table
                  v-if="form.applyType == 2"
                  v-loading="listLoading"
                  size="mini"
                  :data="referenceData"
                  border
                  fit
                  highlight-current-row
                  height="600px"
                >
                  <el-table-column align="center" label="項次" width="60">
                    <template slot-scope="scope">
                      <span>{{ scope.$index + 1 }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column align="center" label="時間" width="180">
                    <template slot-scope="scope">
                      <el-tag>{{ scope.row.buildDate }}</el-tag>
                    </template>
                  </el-table-column>

                  <el-table-column align="center" label="建立者" width="130">
                    <template slot-scope="scope">
                      <el-tag>{{ scope.row.buildUserName }}</el-tag>
                    </template>
                  </el-table-column>

                  <el-table-column align="center" label="建議攜帶物品" width="400">
                    <template slot-scope="scope">
                      <el-button
                        v-if="form.applyType == 2"
                        type="primary"
                        @click="viewReferenceData(scope.row)"
                        :disabled="false"
                        >查看攜帶物品紀錄</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>

                <!-- 說明會上傳紀錄 -->
                <el-table
                  v-if="form.applyType == 3"
                  v-loading="listLoading"
                  size="mini"
                  :data="referenceData"
                  border
                  fit
                  highlight-current-row
                  height="600px"
                >
                  <el-table-column align="center" label="項次" width="60">
                    <template slot-scope="scope">
                      <span>{{ scope.$index + 1 }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column align="center" label="時間" width="180">
                    <template slot-scope="scope">
                      <el-tag>{{ scope.row.buildDate }}</el-tag>
                    </template>
                  </el-table-column>

                  <el-table-column align="center" label="建立者" width="130">
                    <template slot-scope="scope">
                      <el-tag>{{ scope.row.buildUserName }}</el-tag>
                    </template>
                  </el-table-column>

                  <el-table-column align="center" label="查看說明會影片" width="400">
                    <template slot-scope="scope">
                      <el-button
                        v-if="
                          form.applyType == 3 &&
                          scope.row.data.fileInfo &&
                          scope.row.data.fileInfo.length > 0 &&
                          scope.row.data.fileInfo[0].files &&
                          scope.row.data.fileInfo[0].files.length > 0
                        "
                        type="primary"
                        @click="viewReferenceData(scope.row)"
                        :disabled="false"
                        >查看說明會影片</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>

                <!-- 領隊聊天紀錄 -->
                <el-table
                  v-if="form.applyType == 4"
                  v-loading="listLoading"
                  size="mini"
                  :data="referenceData"
                  border
                  fit
                  highlight-current-row
                  height="600px"
                >
                  <el-table-column align="center" label="項次" width="60">
                    <template slot-scope="scope">
                      <span>{{ scope.$index + 1 }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column align="center" label="日期" width="180">
                    <template slot-scope="scope">
                      <el-tag>{{ scope.row.date }}</el-tag>
                    </template>
                  </el-table-column>

                  <el-table-column align="center" label="查看聊天紀錄" width="400">
                    <template slot-scope="scope">
                      <el-button
                        v-if="scope.row.charMsgInfos.length > 0"
                        type="primary"
                        @click="viewReferenceData(scope.row)"
                        :disabled="false"
                        >查看與領隊聊天紀錄</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
                <!-- 導覽對話紀錄 -->
                <el-table
                  v-if="form.applyType == 5"
                  v-loading="listLoading"
                  size="mini"
                  :data="referenceData"
                  border
                  fit
                  highlight-current-row
                  height="600px"
                >
                  <el-table-column align="center" label="項次" width="60">
                    <template slot-scope="scope">
                      <span>{{ scope.$index + 1 }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column align="center" label="日期" width="120">
                    <template slot-scope="scope">
                      <el-tag>{{ scope.row.date }}</el-tag>
                    </template>
                  </el-table-column>

                  <el-table-column align="center" label="時間" width="180">
                    <template slot-scope="scope">
                      <el-tag>{{ scope.row.time }}</el-tag>
                    </template>
                  </el-table-column>

                  <el-table-column align="center" label="檔名" width="200">
                    <template slot-scope="scope">
                      <el-tag>{{ scope.row.fileName }}</el-tag>
                    </template>
                  </el-table-column>

                  <el-table-column align="center" label="大小" width="110">
                    <template slot-scope="scope">
                      <el-tag>{{ scope.row.size }}</el-tag>
                    </template>
                  </el-table-column>

                  <el-table-column align="center" label="查看導覽紀錄" width="200">
                    <template slot-scope="scope">
                      <el-button
                        icon="el-icon-video-play"
                        type="primary"
                        @click="viewReferenceData(scope.row)"
                        :disabled="false"
                        >點我播放</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
                <!-- 定位足跡紀錄 -->
                <el-table
                  v-if="form.applyType == 6"
                  v-loading="listLoading"
                  size="mini"
                  :data="referenceData"
                  border
                  fit
                  highlight-current-row
                  height="600px"
                >
                  <el-table-column align="center" label="項次" width="60">
                    <template slot-scope="scope">
                      <span>{{ scope.$index + 1 }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column align="center" label="日期" width="120">
                    <template slot-scope="scope">
                      <el-tag>{{ scope.row.date }}</el-tag>
                    </template>
                  </el-table-column>

                  <el-table-column align="center" label="景點數量" width="120">
                    <template slot-scope="scope">
                      <el-tag type="danger">{{ scope.row.records.length }}</el-tag>
                      個景點
                    </template>
                  </el-table-column>

                  <el-table-column align="center" label="查看足跡紀錄" width="400">
                    <template slot-scope="scope">
                      <el-button
                        type="primary"
                        @click="viewReferenceData(scope.row)"
                        :disabled="false"
                        >查看足跡紀錄</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>

                <!-- 每日行程資料 -->
                <el-table
                  v-if="form.applyType == 7"
                  v-loading="listLoading"
                  size="mini"
                  :data="referenceData"
                  border
                  fit
                  highlight-current-row
                  height="600px"
                >
                  <el-table-column align="center" label="項次" width="60">
                    <template slot-scope="scope">
                      <span>{{ scope.$index + 1 }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column align="center" label="時間" width="180">
                    <template slot-scope="scope">
                      <el-tag>{{ scope.row.buildDate }}</el-tag>
                    </template>
                  </el-table-column>

                  <el-table-column align="center" label="建立者" width="130">
                    <template slot-scope="scope">
                      <el-tag>{{ scope.row.buildUserName }}</el-tag>
                    </template>
                  </el-table-column>

                  <el-table-column align="center" label="每日行程" width="400">
                    <template slot-scope="scope">
                      <el-button
                        v-if="form.applyType == 7"
                        type="primary"
                        @click="viewReferenceData(scope.row)"
                        :disabled="false"
                        >查看每日行程</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-col>
          </el-row>
        </el-form>
        <div></div>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" type="danger">{{
          form.status == 1 ? '取 消' : '關 閉'
        }}</el-button>

        <el-button v-if="form.status == 1" @click="reject" type="warning">駁 回</el-button>
        <el-button v-if="form.status == 1" type="primary" @click="saveData">審核確認</el-button>
      </span>
    </el-dialog>

    <el-dialog
      v-if="currentChatData && currentChatData.charMsgInfos.length > 0"
      :title="'與領隊聊天紀錄'"
      :visible.sync="chatDialogVisible"
      top="2%"
      width="450px"
    >
      <div
        style="position: relative; height: 100%; padding: 10px"
        v-if="currentChatData.leaderInfo"
      >
        <div class="center">
          <div class="chat">
            <div class="contact bar">
              <div
                class="pic"
                :style="{
                  backgroundImage: 'url(' + currentChatData.leaderInfo.avatar + ')',
                }"
              ></div>
              <div class="name">{{ currentChatData.leaderInfo.name }}</div>
              <div class="seen">{{ currentChatData.date }}</div>
            </div>
            <div class="messages" id="chat">
              <div class="time">聊天紀錄</div>
              <template v-for="(item, index) in currentChatData.charMsgInfos">
                <!-- chat-user 旅客  chat-leader 領隊 -->
                <div
                  style="position: relative"
                  :class="{
                    message: true,
                    'chat-user': item.from != currentChatData.leaderInfo.name,
                    'chat-leader': item.from == currentChatData.leaderInfo.name,
                  }"
                  :key="index"
                >
                  <i
                    v-if="item.from != currentChatData.leaderInfo.name"
                    class="chat-time-chat-user"
                    >{{ item.time }}</i
                  >

                  <span v-if="item.chatType == 1"></span> {{ item.msg }}
                  <template v-if="item.chatType == 2">
                    <el-image
                      v-if="item.fileInfo"
                      style="width: 80px"
                      :src="item.fileInfo.url"
                      fit="fill"
                      :preview-src-list="[item.fileInfo.url]"
                    ></el-image>
                    <span v-else>圖片加載失敗</span>
                  </template>
                  <i
                    v-if="item.from == currentChatData.leaderInfo.name"
                    class="chat-time-chat-leader"
                    >{{ item.time }}</i
                  >
                </div>
              </template>
            </div>
            <div class="input">
              <i class="fas fa-camera"></i><i class="far fa-laugh-beam"></i>
              {{
                `【${currentChatData.userInfo.name}】與【${currentChatData.leaderInfo.name}】領隊聊天紀錄`
              }}
              <!-- <input placeholder="Type your message here!" type="text" /> -->
              <i class="fas fa-microphone"></i>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :top="dialogTopMargin"
      :title="'說明會影片'"
      :visible.sync="seminarMovieDialogVisible"
      width="90%"
    >
      <div style="text-align: center">
        <video :src="currentSeminarMovieUrl" autoplay controls width="500"></video>
      </div>
    </el-dialog>

    <el-dialog
      v-if="currentCarryRow"
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      :title="'攜帶物品異動紀錄'"
      :visible.sync="carryDialogVisible"
      width="90%"
    >
      <el-row>
        <el-col :span="12">
          <div style="position: relative; height: 80%; margin: 5px">
            <el-alert type="success" style="margin: 5px" :closable="false">{{
              `建議攜帶物品 共${currentCarryRow.data.recommended.items.length} 項`
            }}</el-alert>
            <!-- 公告資料 -->
            <el-table
              v-if="currentCarryRow.applyType == 2"
              size="mini"
              :data="currentCarryRow.data.recommended.items"
              border
              fit
              highlight-current-row
              height="600px"
            >
              <el-table-column align="center" label="項次" width="60">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="品項" width="300">
                <template slot-scope="scope">
                  <span>{{ scope.row.description }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>

        <el-col :span="12">
          <div style="position: relative; height: 80%">
            <el-alert type="error" style="margin: 5px" :closable="false">{{
              `必帶物品 共${currentCarryRow.data.required.items.length} 項`
            }}</el-alert>
            <!-- 公告資料 -->
            <el-table
              v-if="currentCarryRow.applyType == 2"
              size="mini"
              :data="currentCarryRow.data.required.items"
              border
              fit
              highlight-current-row
              height="600px"
            >
              <el-table-column align="center" label="項次" width="60">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="品項" width="300">
                <template slot-scope="scope">
                  <span>{{ scope.row.description }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </el-dialog>

    <el-dialog
      v-if="logs.length > 0"
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      :title="'作業紀錄'"
      :visible.sync="logDialogVisible"
      width="60%"
    >
      <div style="position: relative; height: 80%">
        <el-table
          v-loading="listLoading"
          size="mini"
          :data="logs"
          border
          fit
          highlight-current-row
          height="400px"
        >
          <el-table-column align="center" label="項次" width="60">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="日期" width="220">
            <template slot-scope="{ row }">
              <span>{{ row.buildDate }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="狀態" width="120">
            <template slot-scope="scope">
              <el-tag :type="scope.row.beforeStatus | statusFilter">{{
                scope.row.beforeStatusDesc
              }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column align="center" label="狀態(異)" width="120">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status | statusFilter">{{ scope.row.statusDesc }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column align="center" label="備註" width="300">
            <template slot-scope="scope">
              <span>{{ scope.row.remark }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="作業人員" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.buildUserName }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="logDialogVisible = false">關 閉</el-button>
      </span>
    </el-dialog>

    <el-dialog
      v-loading="dialogLoading"
      top="2%"
      :title="'駁回申請'"
      :visible.sync="rejectDialogVisible"
    >
      <el-tag type="success" style="margin: 5px">請輸入駁回原因</el-tag>
      <el-input
        type="textarea"
        :rows="20"
        style="height: 20%"
        v-model="rejectRemark"
        placeholder="請輸入駁回原因"
      ></el-input>

      <span slot="footer" class="dialog-footer">
        <el-button @click="rejectDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="rejectHandle">確 定</el-button>
      </span>
    </el-dialog>

    <div style="padding: 20px; padding-bottom: 0">
      <el-form :inline="true">
        <el-form-item label="查詢">
          <el-input
            v-model="listQuery.qry"
            placeholder="輸入需求人姓名或旅遊團名稱"
            @keyup.enter.native="getList"
          />
        </el-form-item>

        <el-form-item label="狀態">
          <el-select v-model="listQuery.status" clearable placeholder="請選擇">
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="getList">查詢</el-button>
        </el-form-item>

        <el-form-item>
          <el-button
            style="cursor: pointer"
            :loading="listLoading"
            type="success"
            icon="el-icon-refresh-left"
            circle
            @click="refresh()"
          ></el-button>
        </el-form-item>
      </el-form>
    </div>

    <div style="position: relative; height: 80%">
      <el-table
        v-loading="listLoading"
        size="mini"
        :data="list"
        border
        fit
        highlight-current-row
        height="100%"
      >
        <el-table-column align="center" label="項次" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="申請項目" width="200">
          <template slot-scope="scope">
            <el-tag>{{ scope.row.applyTypeDesc }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column align="center" label="狀態" width="120">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status | statusFilter">{{ scope.row.statusDesc }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column align="center" label="團號" width="280">
          <template slot-scope="{ row }">
            <span>{{ row.applyTourNo }}</span>
            <div>
              <el-tag>
                {{ row.applyTravelName }}
              </el-tag>
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="需求旅行社" width="200">
          <template slot-scope="scope">
            <el-tag>{{ scope.row.agencyCode }} - {{ scope.row.agencyName }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column align="center" label="需求人姓名" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.applyUserName }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="申請時間範圍" width="280">
          <template slot-scope="scope">
            <span>{{ scope.row.applyBeginDate }} - {{ scope.row.applyEndDate }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="查看" width="120">
          <template slot-scope="scope">
            <el-button type="success" @click="editData(scope.row)">查看</el-button>
          </template>
        </el-table-column>

        <el-table-column align="center" label="紀錄" width="120">
          <template slot-scope="scope">
            <el-button type="primary" @click="getRecordRequestLog(scope.row.id)">紀錄</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      v-show="total > 0"
      style="padding-top: 0"
      layout="prev, pager, next"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
const NotSetStatus = 0
const AwaitingStatus = 1
const SuccessStatus = 2
const RejectStatus = 3

import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import { MessageBox, Message } from 'element-ui'
import {
  getRecordRequestList,
  getDataReference,
  modifyRecordRequestStatus,
  getRecordRequestLog,
} from '@/api/appManage'
import {
  getTravelDateRangeInfoByTourNo,
  saveViewPoint,
  getTravelAttractionsCascaderMenu,
} from '@/api/travel'

var defaultForm = {
  applyDates: [],
  applyBeginDate: null,
  applyDescription: null,
  applyEndDate: null,
  applyTourNo: null,
  applyTravelID: null,
  applyTravelName: null,
  applyType: null,
  applyUserID: null,
  applyUserName: null,
  id: null,
  reviewDate: null,
  reviewerUserID: null,
  reviewerUserName: null,
  status: 0,
  statusDesc: '未設定',
}

export default {
  name: 'AgencyRecordRequest',
  components: {
    Pagination,
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        0: 'info',
        1: 'warning',
        2: 'success',
        3: 'danger',
      }
      return statusMap[status]
    },
    cuttingText(text) {
      return text ? (text.length > 15 ? `${text.substring(0, 20)}...` : text) : ''
    },
  },
  data() {
    return {
      statusOptions: [
        {
          value: 1,
          label: '待審核',
        },
        {
          value: 2,
          label: '已審核',
        },
      ],
      showUserOptionsApplyTypeIDs: [4, 6],
      planningTab: 'thisTimes',
      vsForm: {
        countryAreaList: [],
        viewPointName: null,
        lat: null,
        lng: null,
      },
      currentItineraryPlanningRow: null,
      currentItineraryPlanningRowVisible: false,
      travelAttractionsMenu: [],
      viewPointDialogVisible: false,
      positionDialogVisible: false,
      currentPositionData: null,
      currentChatData: null,
      chatDialogVisible: false,
      seminarMovieDialogVisible: false,
      currentSeminarMovieUrl: null,
      currentCarryRow: null,
      carryDialogVisible: false,
      logs: [],
      logDialogVisible: false,
      successRemark: null,
      rejectRemark: null,
      rejectDialogVisible: false,
      referenceData: [],
      dateInfoLoading: false,
      funcName: '紀錄資訊需求',
      dialogTopMargin: '1%',
      formLabelWidth: '180px',
      form: {},
      dialogLoading: false,
      dialogVisible: false,
      listLoading: false,
      listQuery: {
        status: 1,
        qry: '',
        date: '',
        page: 1,
        limit: 20,
        sort: '-id',
      },
      dataReferenceQuery: {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
        applyTourNo: null,
        userID: null,
        applyType: null,
        dates: [],
      },
      total: 0,
      list: [],
      tourNumbers: [],
      selectedBeginDate: null,
      selectedEndDate: null,
      travelers: [],
      applyOptions: [],
      pickerOptions: {
        onPick: obj => {
          // console.log("obj", obj); // {maxDate: xxx, minDate: xxx(中国标准时间)}
          this.selectedBeginDate = new Date(obj.minDate).getTime()
          this.selectedEndDate = new Date(obj.maxDate).getTime()
        },
        disabledDate: time => {
          const day1 = 1 * 24 * 3600 * 1000
          let minTime = new Date(this.form.applyDates[0]).getTime()
          let maxTime = new Date(this.form.applyDates[1]).getTime()
          return !(time.getTime() >= minTime - day1 && time.getTime() <= maxTime)
        },
      },
    }
  },
  async created() {
    let vm = this
    this.form = defaultForm
    await this.getTravelAttractionsCascaderMenu()
    await this.getList()
  },
  methods: {
    async refresh() {
      this.listQuery = {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
      }
      await this.getList()
    },
    async getTravelAttractionsCascaderMenu() {
      let resp = await getTravelAttractionsCascaderMenu()
      //只需要到國家

      if (resp.data) {
        resp.data.forEach(f => {
          if (f.children) {
            f.children.forEach(c => {
              c.children = null
            })
          }
        })
      }
      this.travelAttractionsMenu = resp.data
    },
    async addToViewpoint(row) {
      this.vsForm.viewPointName = null
      this.vsForm.lat = row.lat
      this.vsForm.lng = row.lng
      this.viewPointDialogVisible = true
    },
    async saveViewpointData() {
      let vm = this
      if (!confirm(`確定要儲存【景點】資料?`)) {
        return
      }

      this.$refs['vsForm'].validate(async valid => {
        if (valid) {
          vm.dialogLoading = true
          try {
            let resp = await saveViewPoint(this.vsForm)
          } catch (error) {
            vm.dialogLoading = false
            return
          }

          vm.viewPointDialogVisible = false
          vm.positionDialogVisible = false
          vm.dialogVisible = false
          vm.dialogLoading = false
          this.dialogVisible = true
          await vm.getDataReference()

          Message({
            message: '資料處理完成',
            type: 'success',
            duration: 5 * 1000,
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async reject() {
      this.rejectDialogVisible = true
    },
    async googleMap(row) {
      let lat = row.lat
      let lng = row.lng
      let newWindow = window.open(`http://maps.google.com/?q=${lat},${lng}`)
      newWindow.opener = null
    },
    async rejectHandle() {
      if (confirm(`確定要駁回此次申請?`)) {
        this.dialogLoading = true
        await modifyRecordRequestStatus({
          id: this.form.id,
          status: RejectStatus,
          remark: this.rejectRemark,
        })
        this.dialogLoading = false
        this.rejectDialogVisible = false
        this.dialogVisible = false
        await this.getList()
        this.$message({
          message: '已成功將申請駁回!',
          type: 'success',
        })
      }
    },
    async getRecordRequestLog(id) {
      let vm = this
      let resp = await getRecordRequestLog({ id })
      if (resp.data && resp.data.length > 0) {
        vm.logs = resp.data
        vm.logDialogVisible = true
      } else {
        alert('尚無紀錄')
      }
    },
    async viewReferenceData(row) {
      let vm = this
      switch (vm.form.applyType) {
        case 1: //公告
          alert(row.data.bulletinBoard)
          break
        case 2: //攜帶物品
          vm.currentCarryRow = row
          vm.carryDialogVisible = true
          break
        case 3: //說明會
          vm.currentSeminarMovieUrl = row.data.fileInfo[0].files[0].url
          vm.seminarMovieDialogVisible = true
          break
        case 4: //聊天紀錄
          vm.chatDialogVisible = true
          vm.currentChatData = row
          break
        case 5: //導覽紀錄
          let link = row.link
          const newWindow = window.open(link)
          newWindow.opener = null
          break
        case 6: //足跡紀錄
          vm.positionDialogVisible = true
          vm.currentPositionData = row
          break
        case 7: //每日行程
          vm.currentItineraryPlanningRow = row.data
          vm.currentItineraryPlanningRowVisible = true
          break
        default:
          break
      }
    },
    async getDataReference() {
      let vm = this
      vm.dataReferenceQuery.id = this.form.id
      vm.dataReferenceQuery.applyType = this.form.applyType
      vm.dataReferenceQuery.dates = this.form.applyDates
      vm.dataReferenceQuery.userID = this.form.applyUserID
      vm.dataReferenceQuery.tourNo = this.form.applyTourNo
      vm.dataReferenceQuery.travelID = this.form.applyTravelID

      vm.dialogLoading = true

      let resp = await getDataReference(vm.dataReferenceQuery)

      if (this.form.applyType == 4 || this.form.applyType == 5 || this.form.applyType == 6) {
        if (!resp.data.data.data) {
          alert(`查無資料`)
          vm.dialogLoading = false
          return
        }
        vm.referenceData = resp.data.data.data
      } else if (this.form.applyType == 8) {
        vm.successRemark = resp.data.data
      } else {
        if (!resp.data.data) {
          alert(`查無資料`)
          vm.dialogLoading = false
          return
        }
        vm.referenceData = resp.data.data
      }

      vm.dialogLoading = false
    },
    async getTravelDateRangeInfoByTourNo() {
      this.dateInfoLoading = true
      let resp = await getTravelDateRangeInfoByTourNo({
        tourNo: this.form.applyTourNo,
        applyType: this.form.applyType,
      })

      this.dateInfoLoading = false
      if (resp.data && resp.data.dateInfo) {
        this.form.applyDates = [
          `${resp.data.dateInfo.departureDate} ${resp.data.dateInfo.departureTime}`,
          `${resp.data.dateInfo.returnDate} ${resp.data.dateInfo.returnTime}`,
        ]
      }
      if (resp.data && resp.data.travelers) {
        this.travelers = resp.data.travelers
      } else {
        this.form.applyUserID = null
      }
    },
    addData() {
      this.form = defaultForm
      this.dialogVisible = true
    },
    async editData(row) {
      this.form = row
      if (row.id) {
        await this.getTravelDateRangeInfoByTourNo()
      }
      this.dialogVisible = true
    },
    async saveData() {
      let vm = this
      if (!confirm(`確定要送出【${vm.funcName}}】資料?`)) {
        return
      }

      this.$refs['form'].validate(async valid => {
        if (valid) {
          vm.dialogLoading = true
          vm.form.agencyCode = this.agencyCode || ''
          let resp = await modifyRecordRequestStatus({
            id: vm.form.id,
            status: SuccessStatus,
            data: vm.referenceData,
            remark: vm.successRemark,
          })
          await vm.getList()
          this.dialogVisible = false
          vm.dialogLoading = false
          Message({
            message: '資料處理完成，謝謝。',
            type: 'success',
            duration: 5 * 1000,
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async getList() {
      this.listLoading = true
      let resp = await getRecordRequestList(this.listQuery)
      this.list = resp.data.data
      this.total = resp.data.total
      this.listLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=Red+Hat+Display:400,500,900&display=swap');

body,
html {
  font-family:
    Red hat Display,
    sans-serif;
  font-weight: 400;
  line-height: 1.25em;
  letter-spacing: 0.025em;
  color: #333;
  background: #f7f7f7;
}

.center {
  position: relative;
  top: 300px;
  left: calc(50%);
  transform: translate(-50%, -50%);
}

.pic {
  width: 4rem;
  height: 4rem;
  background-size: cover;
  background-position: center;
  border-radius: 50%;
}

.contact {
  position: relative;
  margin-bottom: 1rem;
  padding-left: 5rem;
  height: 4.5rem;

  display: flex;
  flex-direction: column;
  justify-content: center;

  .pic {
    position: absolute;
    left: 0;
  }

  .name {
    font-weight: 500;
    margin-bottom: 0.125rem;
  }

  .message,
  .seen {
    font-size: 0.9rem;
    color: #999;
  }

  .badge {
    box-sizing: border-box;
    position: absolute;
    width: 1.5rem;
    height: 1.5rem;
    text-align: center;
    font-size: 0.9rem;
    padding-top: 0.125rem;
    border-radius: 1rem;

    top: 0;
    left: 2.5rem;
    background: #333;
    color: white;
  }
}

.contacts {
  h2 {
    margin: 0.5rem 0 1.5rem 5rem;
  }

  .fa-bars {
    position: absolute;
    left: 2.25rem;

    color: #999;
    transition: color 200ms;

    &:hover {
      color: #666;
    }
  }

  .contact:last-child {
    margin: 0;
  }

  &:hover {
    transform: translate(-23rem, -50%);
  }
}

.chat {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  width: 24rem;
  height: 38rem;
  z-index: 2;
  box-sizing: border-box;
  border-radius: 1rem;

  background: white;
  box-shadow:
    0 0 8rem 0 rgba(black, 0.1),
    0rem 2rem 4rem -3rem rgba(black, 0.5);

  .contact.bar {
    flex-basis: 3.5rem;
    flex-shrink: 0;
    margin: 1rem;
    box-sizing: border-box;
  }

  .messages {
    min-height: 447px;
    padding: 1rem;
    background: #f7f7f7;
    flex-shrink: 2;
    overflow-y: auto;

    box-shadow:
      inset 0 2rem 2rem -2rem rgba(black, 0.05),
      inset 0 -2rem 2rem -2rem rgba(black, 0.05);

    .time {
      font-size: 0.8rem;
      background: #eee;
      padding: 0.25rem 1rem;
      border-radius: 2rem;
      color: #999;
      width: fit-content;
      margin: 0 auto;
    }

    .message {
      box-sizing: border-box;
      padding: 0.5rem 1rem;
      margin: 1rem;
      background: #fff;
      border-radius: 1.125rem 1.125rem 1.125rem 0;
      min-height: 2.25rem;
      width: fit-content;
      max-width: 66%;

      box-shadow:
        0 0 2rem rgba(black, 0.075),
        0rem 1rem 1rem -1rem rgba(black, 0.1);

      &.chat-user {
        margin: 1rem 1rem 1rem auto;
        border-radius: 1.125rem 1.125rem 0 1.125rem;
        background: #333;
        color: white;
      }

      .typing {
        display: inline-block;
        width: 0.8rem;
        height: 0.8rem;
        margin-right: 0rem;
        box-sizing: border-box;
        background: #ccc;
        border-radius: 50%;

        &.typing-1 {
          animation: typing 3s infinite;
        }

        &.typing-2 {
          animation: typing 3s 250ms infinite;
        }

        &.typing-3 {
          animation: typing 3s 500ms infinite;
        }
      }
    }
  }

  .input {
    box-sizing: border-box;
    flex-basis: 4rem;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    padding: 0 0.5rem 0 1.5rem;

    i {
      font-size: 1.5rem;
      margin-right: 1rem;
      color: #666;
      cursor: pointer;
      transition: color 200ms;

      &:hover {
        color: #333;
      }
    }

    input {
      border: none;
      background-image: none;
      background-color: white;
      padding: 0.5rem 1rem;
      margin-right: 1rem;
      border-radius: 1.125rem;
      flex-grow: 2;
      box-shadow:
        0 0 1rem rgba(black, 0.1),
        0rem 1rem 1rem -1rem rgba(black, 0.2);

      font-family:
        Red hat Display,
        sans-serif;
      font-weight: 400;
      letter-spacing: 0.025em;

      &:placeholder {
        color: #999;
      }
    }
  }
}

.chat-time-chat-leader {
  right: -40px;
  position: absolute;
  color: darkslateblue;
}

.chat-time-chat-user {
  left: -40px;
  position: absolute;
  color: darkslateblue;
}

@keyframes typing {
  0%,
  75%,
  100% {
    transform: translate(0, 0.25rem) scale(0.9);
    opacity: 0.5;
  }

  25% {
    transform: translate(0, -0.25rem) scale(1);
    opacity: 1;
  }
}
</style>

<style scoped>
.full-height {
  position: relative;
  height: 100%;
}

.el-dialog__body {
  padding-top: 0px;
}
.el-date-range-picker__time-header > span:nth-child(1) > span:nth-child(1) > div > input,
.el-date-range-picker__time-header
  > span.el-date-range-picker__editors-wrap.is-right
  > span:nth-child(1)
  > div
  > input {
  pointer-events: none;
  background-color: #ccc;
}

.view-point-app-container .is-disabled * {
  color: rgb(44, 192, 147) !important;
}

/deep/.itinerary .is-disabled * {
  color: blue !important;
}

/deep/:disabled {
  color: blue !important;
}
</style>
